import { render } from "./HelloWorld.vue?vue&type=template&id=4d44e63a&scoped=true&lang=pug"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=4d44e63a&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-4d44e63a"

export default script